import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { type DatiSessioneUtente } from '@framework/api-client/api/users/schemas/datiSessioneUtente.ts';
import { type IDelegationData } from '@framework/frontoffice-submission/module/delegation/DelegationLogic.ts';
import {
  DelegationMachine,
  isApplicant,
} from '@framework/frontoffice-submission/module/delegation/DelegationMachine.ts';

export function checkCanEditAttorney(props: {
  delegationData: IDelegationData;
  user: DatiSessioneUtente | null;
  inquiry:
    | Pick<TipoDomandaDTO, 'flProcuraEsplicita' | 'flProcuraImplicita'>
    | undefined;
}): boolean {
  const { delegationData, user, inquiry } = props;

  if (!inquiry) return false;

  // Se non c'è la procura esplicita, il pulsante non è visibile
  // perché il procuratore può essere modificato solo attraverso
  // il form (procura automatica/modifica del form/...)
  if (!inquiry.flProcuraEsplicita) {
    return false;
  }

  const canEditAttorney = DelegationMachine.can(
    delegationData,
    '.editAttorney',
    user,
  );

  // Se c’è la flProcuraImplicita e flProcuraEsplicita, è abilitato (non contano gli altri flag) per gli utenti con sufficienti permessi
  if (inquiry.flProcuraImplicita) {
    return canEditAttorney.allowed;
  }

  // Essendoci solo la flProcuraEsplicita, è abilitato solo per il titolare con permessi sufficienti (gestore)
  return canEditAttorney.allowed && isApplicant(delegationData, user);
}
